import React from 'react';
import { inputPropTypes } from 'Packages/FacetDesign/Components/propTypes';
import WebAppRichTextDisplay from 'Components/UI/RichTextDisplay';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { useDataAttrs } from 'Helpers/Testing';
import classNames from 'classnames';

const useStyles = buildUseStyles('RichTextDisplay', (theme) => ({
  fontSizeSm: {
    fontSize: theme.typography.body1.fontSize,
  },
}));

/**
 * @deprecated: use RichText
 */
export const RichTextDisplay = (props) => {
  const {
    value,
    className,
    ...rest
  } = props;

  const classes = useStyles();

  return (
    <WebAppRichTextDisplay
      {...useDataAttrs(rest)}
      className={classNames(classes.fontSizeSm, className)}
      content={value}
    />
  );
};

RichTextDisplay.propTypes = {
  value: inputPropTypes.value.isRequired,
};
